// Libraries
import React from 'react'
import { ModuleNames } from '../../../../constants/componentNames.constants'
import { LocaleCodes } from '../../../../constants/localization.constants'
import Layout from '../../../layouts/layout'

// Components
import ContentBlock from '../../../global/contentBlock'
import GlobalContainer from '../../../global/globalContainer'
import ProductDownload from '../../../global/productDownload'
import ResourceRow from '../../../global/resourceRow'
import SEOTags from '../../../global/seoTags'
import Slider from '../../../global/slider'
import Tiles from '../../../global/tiles'
import Typography from '../../../global/typography'
import VideoSpotlight from '../../../global/videoSpotlight'

// Styles
import { ProductDownloadWrapper, ThankYouWrapper } from './style'

// Helpers
import ImgUtil from '../../../../utils/img.utils'
import WrapperImage from '../../../global/wrapperImage'

const ProductDownloadPage = ({
  path,
  pageContext,
  location,
  headerData,
  footerData,
  announcementData,
  browserLanguageData,
}: any) => {
  let dynamicPageContent: any, pageData: any
  let h1Title = ''
  let mainImage = {
    altText: 'UiPath',
    url: '/',
  }
  if (pageContext && pageContext.pageData) {
    pageData = pageContext.pageData
  }

  let defaultLocale: string
  if (pageContext && pageContext.pageLocale) {
    defaultLocale = pageContext.pageLocale
  } else {
    defaultLocale = LocaleCodes.ENGLISH.code
  }

  if (pageData && pageData.flexSection) {
    const productDownloadPageContent = pageData.flexSection
    dynamicPageContent = productDownloadPageContent.map((module: any, i: Number) => {
      switch (module.__typename) {
        case ModuleNames.TILES:
          return <Tiles data={module} key={`page-component--${i}`}></Tiles>
        case ModuleNames.PRODUCT_DOWNLOAD_COMPONENT:
          return <ProductDownload data={module} key={`page-component--${i}`} />
        case ModuleNames.SLIDER:
          return <Slider data={module} key={`page-component--${i}`}></Slider>
        case ModuleNames.VIDEO_SPOTLIGHT:
          return (
            <VideoSpotlight
              data={module}
              useCase={'horizontal'}
              key={`page-component--${i}`}></VideoSpotlight>
          )
        case ModuleNames.GLOBAL_CONTENT_BLOCK:
          return <ContentBlock data={module} key={`page-component--${i}`}></ContentBlock>
        case ModuleNames.RESOURCE_ROW:
          return (
            <ResourceRow
              data={module}
              key={`page-component--${i}`}
              loacle={defaultLocale}></ResourceRow>
          )
        case ModuleNames.HERO:
          if (module.headline) {
            h1Title = module.headline
          }
          if (module.backgroundAsset) {
            if (module.backgroundAsset.altText) {
              mainImage.altText = module.backgroundAsset.altText
            }
            if (module.backgroundAsset.image) {
              const image = module.backgroundAsset.image
              if (image && image.file && image.file.url) {
                mainImage.url = image.file.url
              }
            }
          }
      }
    })
  }

  const renderDownloadPage = () => {
    return (
      <GlobalContainer>
        <ProductDownloadWrapper>
          <div className="ProductDownload__Download-Container">
            <Typography type="header1" className="ProductDownload__Heading">
              {h1Title}
            </Typography>
            {dynamicPageContent}
          </div>
          <div className="ProductDownload__Featured-Image-Container">
            <WrapperImage
              src={ImgUtil.getResizedImageUrl(
                'https://images.ctfassets.net/5965pury2lcm/7eoe48KGKSX7VAaQCRRcgV/ac321357dee0cd83ae6bbe6411a6b27d/Product-Download-Page-Macaroni.png',
                `width=750`
              )}
              alt="Half moon shape"
              className="ProductDownload__Featured-Image-Macaroni"
              width={588}
              height={588}
              threshold={650}
            />
            <WrapperImage
              className="ProductDownload__Featured-Image-File"
              src={ImgUtil.getResizedImageUrl(mainImage.url, `width=750`)}
              alt={mainImage.altText}
              width={750}
              height={750}
              threshold={650}
            />
          </div>
        </ProductDownloadWrapper>
      </GlobalContainer>
    )
  }

  const renderThankYouPage = () => {
    return <ThankYouWrapper>{dynamicPageContent}</ThankYouWrapper>
  }

  const defaultSlug = pageData && pageData.slug ? pageData.slug : '/'
  const seoData = pageData && pageData.seoMetadata ? pageData.seoMetadata : null
  const pageUseCase = pageData && pageData.useCase ? pageData.useCase : ''

  const siteSection = 'Product Download'
  const pageInner = (
    <div data-cy={'ProductDownloadPage'}>
      <SEOTags
        seoMetadata={seoData}
        slug={defaultSlug}
        path={path}
        locale={defaultLocale}
        siteSection={siteSection}
      />

      {pageUseCase && pageUseCase === 'Product Download Thank You'
        ? renderThankYouPage()
        : renderDownloadPage()}
    </div>
  )

  return (
    <Layout.Template
      minimalHeader={true}
      minimalFooter={true}
      headerData={headerData}
      footerData={footerData}
      announcementData={announcementData}
      browserLanguageData={browserLanguageData}
      lang={defaultLocale}
      slug={defaultSlug}>
      {pageInner}
    </Layout.Template>
  )
}

export default ProductDownloadPage
